module.exports = __webpack_public_path__ + "static/img/10.a36ac48.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/10.png
// module id = 7TuL
// module chunks = 4